import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Typography, Stack, Box, Grid, Paper } from '@mui/material';
// components
import Iconify from '../../../../components/Iconify';

// ----------------------------------------------------------------------

const ServiceCard = styled(Paper)(({ theme, bordercolor }) => ({
  padding: theme.spacing(3),
  borderRadius: 24,
  border: `1px solid ${bordercolor || '#F1F5F9'}`,
  boxShadow: 'none',
  background: '#FFF',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  height: '100%',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 12px 24px rgba(0,0,0,0.04)',
  }
}));

const IconBox = styled(Box)(({ theme, bgcolor, color }) => ({
  width: 48,
  height: 48,
  borderRadius: 12,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: bgcolor || '#F8FAFC',
  color: color || '#6366F1',
  marginBottom: theme.spacing(2),
}));

// ----------------------------------------------------------------------

YangaServiceGrid.propTypes = {
  services: PropTypes.array,
};

export default function YangaServiceGrid({ services }) {
  return (
    <Grid container spacing={3}>
      {services.map((service, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <ServiceCard 
            bordercolor={service.color + '40'} 
            onClick={() => window.location.href = service.link}
          >
            <IconBox bgcolor={service.color + '10'} color={service.color}>
              <Iconify icon={service.icon} width={24} height={24} />
            </IconBox>
            <Typography variant="h6" sx={{ fontWeight: 800, mb: 1 }}>
              {service.title}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.6 }}>
              {service.description}
            </Typography>
          </ServiceCard>
        </Grid>
      ))}
    </Grid>
  );
}
